/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'cross-flow-support.back-to-all-products': 'Volver a todas las aplicaciones',
  'cross-flow-support.close': 'Cerrar',
  'cross-flow-support.product-store': 'Tienda de aplicaciones',
};
